import axios, { AxiosResponse }                from 'axios';
import { useMutation, useQuery, useQueryClient }         from 'react-query';
import { IErrorResponse, IRequestResponse }    from '../../../../../Auth/shared/interfaces';
import { Notistack }                           from '../../../../../shared/components/Notistack/Notistack';
import { TCreateQueryOptions, useCreateQuery } from '../../../../../shared/utils/hooks/useReactQuery';
import { CHATS }                               from '../../../../MessageCenter/queries';
import { IFamilyUserPermissions }              from '../../ManageFamilyAccount/ManageAccountForm/ManageAccountForm';

export const FAMILY_USER_PERMISSIONS_GET = 'FAMILY_USER_PERMISSIONS_GET';
export const FAMILY_USER_PERMISSIONS_UPDATE = 'FAMILY_USER_PERMISSIONS_UPDATE';

interface PrivacySetting {
  // familyUserId: string;
  // blockedFamilyUserIds: string[];
  data: any;
}

export const useFetchUserPermissions = (
  familyUserId?: string,
  options?: TCreateQueryOptions<IFamilyUserPermissions>
) => useCreateQuery<IFamilyUserPermissions>({
  queryKey : [ FAMILY_USER_PERMISSIONS_GET, familyUserId ],
  apiUrl   : `/api/v1/family-users-permissions/${ familyUserId }`,
  options  : {
    enabled              : !!familyUserId,
    refetchOnWindowFocus : false,
    ...options,
  },
});

export const updateUserPermissions = (
  data: IFamilyUserPermissions,
  familyUserId?: string,
) =>
  axios.put(`/api/v1/family-users-permissions/${ familyUserId }`, data)
    .then(({ data: { data } }: AxiosResponse<IRequestResponse<IFamilyUserPermissions>>) => data)
    .catch((error: IErrorResponse) => {
      throw error;
    });

export const useUpdateUserPermissions = (
  familyUserId?: string,
) => {
  const queryClient = useQueryClient();
  return useMutation(
    FAMILY_USER_PERMISSIONS_UPDATE,
    (
      data: IFamilyUserPermissions
    ) => updateUserPermissions(data, familyUserId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ FAMILY_USER_PERMISSIONS_GET, familyUserId ]);
        queryClient.invalidateQueries(CHATS);
        Notistack.enqueueSnackbar('User permissions were successfully updated.', 'success');
      },
    }
  );
};

const updateChatPrivacySettings = async (
  familyId: string,
  data: PrivacySetting[]
): Promise<AxiosResponse> => {
  const response = await axios.put(`/api/v1/ChatPrivacySettings?familyId=${familyId}`, data);
  return response;
};

export const useUpdateChatPrivacySettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ familyId, data }: { familyId: string; data: PrivacySetting[] }) =>
      updateChatPrivacySettings(familyId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('chatPrivacySettings');
      },
    }
  );
};

// // Типы
// interface PrivacySetting {
//   familyUserId: string;
//   blockedFamilyUserIds: string[];
// }

// GET запрос
export const fetchChatPrivacySettings = (familyId: string): Promise<any> =>
  axios.get<any>(`/api/v1/ChatPrivacySettings?familyId=${familyId}`)
    .then(({ data }: AxiosResponse<any[]>) => data)
    .catch((error: IErrorResponse) => {
      console.error('Failed to fetch chat privacy settings:', error);
      throw error;
    });

// Хук для React Query
export const useFetchChatPrivacySettings = (familyId: string) => {
  const queryClient = useQueryClient();

  return useQuery<any, Error>(
    ['chatPrivacySettings', familyId],
    () => fetchChatPrivacySettings(familyId),
    {
      enabled   : !!familyId,
      onSuccess : () => {
        queryClient.invalidateQueries(['userPermissions']);
      },
    }
  );
};
